import React from "react";
import { localize } from "redux-i18n";
import { compose } from "redux";
import { View, Form, FormGroup, Label, Input, DatePicker, Button, Text } from "@components";

type Props = {
  handleSubmit: Function,
  onChange: Function,
  data: Object,
  showAbsenceId?: boolean,
  isValid?: boolean,
  requiredFields?: Array<string>,
};

export function AuditLogsFilter(props: Props) {
  const data = props.data || {};

  const requiredFields = ["dateFrom", ...(props.requiredFields || [])];

  // if isValid is not defined, it will be true by default
  const isValid = props.isValid === undefined ? true : props.isValid;
  const canSubmit = isValid && !!data.dateFrom;

  const emit = (field, value) => {
    props.onChange({ ...data, [field]: value });
  };

  const renderLabel = (field, text) => (
    <Label for={field} className="d-flex justify-content-between align-items-center pr-1">
      {props.t(text)}
      <Text
        className={`text-warning font-size-16 ml-1 ${
          requiredFields.includes(field) ? "" : "invisible"
        }`}
      >
        *
      </Text>
    </Label>
  );

  const submitForm = e => {
    e.preventDefault();
    props.handleSubmit();
  };

  return (
    <Form onSubmit={submitForm}>
      <View direction="row" gap={4} justifyContent="center" alignItems="flex-end">
        <FormGroup>
          {renderLabel("dateFrom", "FROM")}
          <DatePicker
            id="dateFrom"
            value={data.dateFrom}
            onChange={value => emit("dateFrom", value || null)}
          />
        </FormGroup>
        <FormGroup>
          {renderLabel("dateTo", "TO")}
          <DatePicker
            id="dateTo"
            value={data.dateTo}
            onChange={value => emit("dateTo", value || null)}
          />
        </FormGroup>
        <FormGroup>
          {renderLabel("userId", "USER_ID")}
          <Input
            id="userId"
            value={data.userId || ""}
            onChange={e => emit("userId", e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          {renderLabel("employeeId", "EMPLOYEE_ID")}
          <Input
            id="employeeId"
            value={data.employeeId || ""}
            onChange={e => emit("employeeId", e.target.value)}
          />
        </FormGroup>
        {props.showAbsenceId && (
          <FormGroup>
            {renderLabel("absenceId", "ABSENCE_ID")}
            <Input
              id="absenceId"
              value={data.absenceId || ""}
              onChange={e => emit("absenceId", e.target.value)}
            />
          </FormGroup>
        )}
        <FormGroup>
          <Button materialIcon="replay_circle_filled" type="submit" disabled={!canSubmit}>
            {props.t("SUBMIT")}
          </Button>
        </FormGroup>
      </View>
    </Form>
  );
}

export default compose(localize())(AuditLogsFilter);
